module.exports = ".service-nav {\r\n    display: block;\r\n    float: right;\r\n}\r\n\r\n.service-nav-item {\r\n    display: inline-block;\r\n}\r\n\r\n.personalLink {\r\n    min-width: 90%;\r\n    min-height: 20px;\r\n    position: absolute;\r\n    z-index: 9;\r\n    top: 13px;\r\n    cursor: pointer;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dashboard/navigation/navigation.component.css
// module id = ./src/app/components/dashboard/navigation/navigation.component.css
// module chunks = main